define.alias("shared/components/shared/expandable-truncated-text", "preview-grid/components/shared/expandable-truncated-text");